import type { UsageRatingStatus } from '@nadoutong/contracts';

/**
 * Whether an operator surface should render a cost or a pending marker
 * (#1410 storage-autonomy P3).
 *
 * `?? 'rated'` is the load-bearing default, for two independent reasons:
 * every historical row predates the field, and during the deploy window
 * ops-api relays responses from a gateway that does not emit it yet
 * (platform deploys before the gateway — root CLAUDE.md). Defaulting to
 * 'pending' would paint the entire request history as unsettled, which is a
 * louder lie than the one this predicate fixes.
 *
 * `not_billable` is deliberately not pending: it is a real, final ¥0.00 for
 * an unpriced or quarantined request.
 *
 * The two operator row shapes carry this field under different names
 * (`OpsUsageRequestRow.ratingStatus` vs `OpsSupportRequestRow.rating_status`),
 * so the accessor stays at each call site and only the predicate is shared.
 */
export function isRatingPending(status: UsageRatingStatus | undefined): boolean {
  return (status ?? 'rated') === 'pending';
}
